// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vm2__header {\n  font-weight: 700;\n  font-size: 1.125rem;\n  line-height: 1.75rem;\n}\n.vm2_body {\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  padding-left: 1.25rem;\n  padding-right: 1rem;\n}\n", ""]);
// Exports
module.exports = exports;
